<template>
    <div class="w-100">
        <label :for="id" class="pb-2 d-block font-weight-medium text-size-md">
            {{ label }}
        </label>
        <v-text-field
            :id="id"
            v-model="modelValue"
            v-maska="mask"
            :variant="variant"
            :maxlength="max"
            :minlength="min"
            :label="placeholder"
            :counter="counter"
            :type="type"
            :readonly="readonly"
            :required="required"
            :persistent-counter="counter"
            :rules="validationRules"
            :append-inner-icon="getAppendIcon"
            :validate-on="validateOn"
            :color="isValid ? 'success' : undefined"
            :disabled="disabled"
            :on-click:append-inner="appendClick"
        >
        </v-text-field>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { vMaska } from 'maska/vue';
import { IInputField } from '../../types';
import { useValidation } from '../../composables';
import { FIELD_TYPES } from '../../constants';

const modelValue = defineModel<string>('modelValue');

const emit = defineEmits(['click']);

const appendClick = () => {
    emit('click');
};

const props = withDefaults(defineProps<IInputField>(), {
    variant: 'outlined',
    type: 'default',
    counter: false,
    disabled: false,
    readonly: false
});

const { rules, registrationRules, createMatchValidator, validateRules, getIconStatus } = useValidation(props);

const isReferenceValue: boolean = props.referenceValue != undefined;

const validationRules =
    props.type == FIELD_TYPES.PASSWORD
        ? [rules.required, isReferenceValue ? createMatchValidator(props.referenceErrorLabel) : registrationRules.registerPassword]
        : [
              rules.required,
              rules.max,
              rules.min,
              rules.pattern,
              ...(isReferenceValue ? [createMatchValidator(props.referenceErrorLabel)] : [])
          ];

const isValid = computed(() => validateRules(modelValue.value));

const getAppendIcon = computed(() => props.icon ?? getIconStatus(modelValue.value, isValid.value));
</script>
